import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { useIntl } from 'react-intl';
import { useForm, Controller } from 'react-hook-form';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import PhoneNumberInput from '@lib/inputs/PhoneNumberInput';
import { INPUT_TYPES } from '@constants/inputs/inputTypes';
import { VALIDATION_TYPES } from '@constants/inputs/validationTypes';
import { RECAPTCHA_EXECUTE_ACTION } from '@constants/common.constants';
import { useReCaptchaErrorModal } from '@hooks/useReCaptchaErrorModal';
import { useReCaptcha } from '@components/common/form/recaptcha/useReCaptcha';
import { ConditionalRendering } from '@components/common/conditional-rendering';
import { ErrorModal } from '@components/errorModal/ErrorModal';

// Components
import { GIButton } from 'app-components';

type FormValues = {
    phonenumber: string
    lastname: string
    captcha: string
}
  

const ForgotEmail = (props) => {

    const {
        onSubmit,
    } = props;

    const intlApi = useIntl();
    const { getReCaptchaToken, isCaptchaReady } = useReCaptcha();
    const { errorMessage, errorTitleId, showRecaptchaError, resetError } = useReCaptchaErrorModal();

    const { clearErrors, control, setValue, setError, register, handleSubmit, formState: { errors, isSubmitted }  } = useForm<FormValues>({ defaultValues:{} });

    const onSubmitWrapped = async (data) => {
        resetError();
        const captchaToken = await getReCaptchaToken(RECAPTCHA_EXECUTE_ACTION.FORGOT_EMAIL);
        if (captchaToken === null) {
            showRecaptchaError();
            return;
        }
        data.captcha = captchaToken;
        await onSubmit(data);
    };

    const handlePhoneChange = (value) => {
        setValue('phonenumber', value);
        if(isSubmitted){
            value ?  clearErrors('phonenumber') : setError('phonenumber', { type: 'focus' }, { shouldFocus: true });
        }
    };

    return (
        <Fragment>
            <form
                className="grid-col-12"
                onSubmit={handleSubmit(onSubmitWrapped)}
            >
                <Controller
                    name="phonenumber"
                    control={control}
                    rules={{ required: true }}
                    render={() => (
                        <PhoneNumberInput
                            label={{
                                text: intlApi.formatMessage({ id: 'anonymous.forgot_email.label.phoneNumber' }),
                                labelClasses: ['gi-regular_input__label', 'gi-input']
                            }}
                            inputData={{
                                id:'forgotemail_num',
                                isInputRequired: false,
                                type: INPUT_TYPES.PHONE_NUMBER_INPUT,
                                helperClasses: [],
                                name:'phonenumber',
                                value: '',
                                placeholder: '(xxx) xxx-xxxx',
                                validationType: VALIDATION_TYPES.PHONE_NUMBER,
                                currentData: '',
                                fields: [],
			                    mask: true,
                            }}
                            inputActions={{
                                handleFieldChange: handlePhoneChange,
                            }}
                        />
                    )}       
                />
                <div className='tablet:grid-offset-4'>
                    {(errors.phonenumber) && <p className="shown error--msg"><em><FontAwesomeIcon icon="exclamation"/></em><FormattedMessage id='anonymous.forgot_email.label.phoneNumber.patteren' /></p>}
                </div>
                <div className="grid-row gi-component gi-regular_input">
                    <label htmlFor="forgotemail_lastname" className="tablet:grid-col-4 gi-regular_input__label gi-input ticket-form__label">
                        <FormattedMessage id='anonymous.forgot_email.label.lastName' />
                    </label>
                    <input
                        id='forgotemail_lastname'
                        data-testid='forgotemail_lastname'
                        type='text'
                        className={'tablet:grid-col-6 gi-regular_input__input'}
                        {...register('lastname', { required: true })}
                    />
                    <div className='tablet:grid-offset-4'>
                        {errors.lastname && <p className="shown error--msg"><em><FontAwesomeIcon icon="exclamation"/></em><FormattedMessage id='anonymous.forgot_email.label.lastName.required' /></p>}
                    </div>
                </div>
                <div className="grid-row controls-container">
                    <div className='tablet:grid-offset-4 mobile:grid-col-12'>
                        <GIButton id='updateNewTicketCategory' labelId={'anonymous.forgot_email.submit'} isDisabled={!isCaptchaReady} />
                    </div>
                </div>
            </form>
            <ConditionalRendering isTrue={errorMessage.length > 0}>
                <ErrorModal
                    onClose={resetError}
                    errorText={errorMessage}
                    titleId={errorTitleId}
                />
            </ConditionalRendering>
        </Fragment>
    );
};

export default ForgotEmail;